import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon, ArrowDownIcon } from 'lucide-react';
const bonuses = [{
  number: 1,
  title: 'Checklist Maestro de Autocuidado Diario',
  subtitle: 'Tu lista de verificación lista para imprimir y usar cada día',
  image: 'https://cdn.magicpatterns.com/uploads/fjFKUfzoRwV57AFvqZiKn2/FHOTO_BONO_1_RUTINA_1777565446319.png',
  copy: ['Olvídate de intentar recordar qué revisar cada mañana.', 'Este checklist maestro te da una lista clara, ordenada y lista para imprimir — o guardar en tu teléfono — con todo lo que necesitas verificar cada día.', 'Sin adivinar. Sin olvidar. Sin complicaciones.', 'Solo marcas, avanzas y te sientes bien con tu rutina.']
}, {
  number: 2,
  title: 'Guía Rápida de Calzado Cómodo',
  subtitle: 'Cómo elegir mejor lo que usas cada día sin gastar de más',
  image: 'https://cdn.magicpatterns.com/uploads/6LLV5VstfVNJx7JDuGQ2SB/BONO_2_FHOTA_RUTINA_.png',
  copy: ['Lo que pones en tus pies cada mañana influye en cómo te sientes todo el día.', 'Esta guía rápida te explica en palabras simples qué buscar — y qué evitar — cuando eliges tu calzado diario.', 'Sin marcas. Sin precios exagerados. Solo criterios claros para tomar mejores decisiones desde hoy.', 'Porque un buen zapato no siempre es el más caro. A veces es simplemente el más amable.']
}, {
  number: 3,
  title: 'Plan de 7 Días para Crear tu Rutina',
  subtitle: 'Un plan diario simple para convertir la guía en un hábito real',
  image: 'https://cdn.magicpatterns.com/uploads/onHnJsFK2uXSnpsWzrXrkd/BONO_3_FHOTO_RUTINA_.png',
  copy: ['Saber qué hacer no siempre es suficiente.', 'Este plan de 7 días te guía paso a paso durante tu primera semana — con una acción pequeña y clara para cada día — para que la rutina no se quede guardada en tu teléfono sino que se convierta en parte de tu vida.', 'Día 1. Día 2. Día 3. Todo claro. Todo simple. Todo en español.', 'Porque los hábitos no se construyen en un día — pero sí empiezan en uno.']
}];
export function Bonuses() {
  const scrollToComprar = () => {
    const el = document.querySelector('#comprar');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="bonos" className="py-24 bg-cream-dark/30" data-id="element-32">
      <div className="max-w-5xl mx-auto px-6" data-id="element-33">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-8" data-id="element-34">
          <h2 className="text-3xl md:text-5xl font-serif mb-6 leading-tight" data-id="element-35">
            "Y eso no es todo lo que recibes hoy."
          </h2>
          <div className="w-16 h-[1px] bg-bronze mx-auto mb-8" data-id="element-36" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        delay: 0.1
      }} className="max-w-3xl mx-auto text-center mb-16" data-id="element-37">
          <p className="text-lg text-charcoal-light leading-relaxed mb-4" data-id="element-38">
            Cuando decides empezar tu rutina de autocuidado hoy, no solo recibes
            la guía principal.
          </p>
          <p className="text-lg text-charcoal-light leading-relaxed mb-4" data-id="element-39">
            Decidimos agregar{' '}
            <strong className="text-charcoal" data-id="element-40">3 bonos especiales</strong> — sin
            costo adicional — porque queremos que tengas todo lo que necesitas
            para empezar con confianza, claridad y sin excusas.
          </p>
          <p className="text-lg text-charcoal-light leading-relaxed mb-2" data-id="element-41">
            Estos bonos tienen un valor real de{' '}
            <strong className="text-charcoal" data-id="element-42">$14.00 cada uno</strong>.
          </p>
          <p className="text-xl font-serif text-bronze-dark font-semibold" data-id="element-43">
            Hoy los recibes completamente gratis.
          </p>
        </motion.div>

        {/* Bonus Cards */}
        <div className="space-y-20" data-id="element-44">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className={`flex flex-col ${index % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-10 items-center`} data-id="element-45">
              {/* Image */}
              <div className="w-full md:w-1/2" data-id="element-46">
                <div className="relative overflow-hidden rounded-sm shadow-xl shadow-bronze/10 border border-bronze/15" data-id="element-47">
                  <img src={bonus.image} alt={bonus.title} className="w-full object-cover" data-id="element-48" />
                </div>
              </div>

              {/* Content */}
              <div className="w-full md:w-1/2" data-id="element-49">
                <div className="flex items-center gap-3 mb-4" data-id="element-50">
                  <div className="w-10 h-10 rounded-full bg-bronze/15 flex items-center justify-center" data-id="element-51">
                    <GiftIcon className="w-5 h-5 text-bronze-dark" data-id="element-52" />
                  </div>
                  <span className="text-sm font-semibold tracking-widest uppercase text-bronze-dark" data-id="element-53">
                    Bono #{bonus.number}
                  </span>
                </div>

                <h3 className="text-2xl md:text-3xl font-serif mb-2 leading-snug" data-id="element-54">
                  {bonus.title}
                </h3>
                <p className="text-bronze-dark font-medium mb-6 italic" data-id="element-55">
                  {bonus.subtitle}
                </p>

                <div className="space-y-3 text-charcoal-light leading-relaxed mb-6" data-id="element-56">
                  {bonus.copy.map((paragraph, pIndex) => <p key={pIndex} data-id="element-57">{paragraph}</p>)}
                </div>

                <div className="flex items-center gap-3" data-id="element-58">
                  <span className="text-charcoal-light line-through" data-id="element-59">
                    Valor: $14.00
                  </span>
                  <span className="text-bronze-dark font-bold text-lg" data-id="element-60">
                    → Tuyo gratis hoy
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}